<script setup>
import { useTranslation } from '@composables/useTranslation';

const { t } = useTranslation();
</script>
<template>
    <div class="inline-flex items-center justify-center px-1.5 h-6 text-[12px] rounded-2xl  border border-green-600 text-green-600">
        <slot v-if="$slots.default"/>
        <span>{{ t('new') }}</span>
    </div>
</template>